/**
 * Wishlist functionality
 */
document.addEventListener("DOMContentLoaded", function () {
  // Elements
  const wishlistItems = document.getElementById("wishlist-items");
  const wishlistLoading = document.getElementById("wishlist-loading");
  const wishlistEmpty = document.getElementById("wishlist-empty");
  const wishlistLoadMore = document.getElementById("wishlist-load-more");
  const loadMoreButton = document.getElementById("load-more-button");
  const wishlistLoadingMore = document.getElementById("wishlist-loading-more");
  const wishlistNotifications = document.getElementById(
    "wishlist-notifications"
  );

  // State
  let currentPage = 1;
  let hasMore = false;
  let isLoading = false;

  // Initialize
  loadWishlistItems();

// Event delegation for wishlist items
wishlistItems.addEventListener('click', function(event) {
    const target = event.target;
    
    // Remove from wishlist button
    if (target.closest('.remove-from-wishlist-btn')) {
        const item = target.closest('.wishlist-item');
        const productId = parseInt(item.dataset.productId, 10);
        removeFromWishlist(item, productId);
    }
    
    // Add to cart button
    if (target.closest('.add-to-cart-btn')) {
        const button = target.closest('.add-to-cart-btn');
        const item = button.closest('.wishlist-item');
        const productId = parseInt(item.dataset.productId, 10);
        const productType = item.dataset.productType;
        const productUrl = item.dataset.productUrl;
        
        // If it's a variable product, redirect to the product page
        if (productType === 'variable') {
            window.location.href = productUrl;
            return;
        }
        
        // For simple products, add directly to cart
        addToCart(button, item, productId, 0);
    }
    
    // Quantity increase button
    if (target.closest('.quantity-increase')) {
        const button = target.closest('.quantity-increase');
        const quantityContainer = button.closest('.wishlist-item-quantity');
        const item = button.closest('.wishlist-item');
        const productId = parseInt(item.dataset.productId, 10);
        const variationId = item.dataset.variationId ? parseInt(item.dataset.variationId, 10) : 0;
        const productType = item.dataset.productType;
        
        // If it's a variable product without variation ID, redirect to product page
        if (productType === 'variable' && !variationId) {
            window.location.href = item.dataset.productUrl;
            return;
        }
        
        updateCartQuantity(quantityContainer, item, productId, variationId, 'increase');
    }
    
    // Quantity decrease button
    if (target.closest('.quantity-decrease')) {
        const button = target.closest('.quantity-decrease');
        const quantityContainer = button.closest('.wishlist-item-quantity');
        const item = button.closest('.wishlist-item');
        const productId = parseInt(item.dataset.productId, 10);
        const variationId = item.dataset.variationId ? parseInt(item.dataset.variationId, 10) : 0;
        updateCartQuantity(quantityContainer, item, productId, variationId, 'decrease');
    }
});

  // Load more button
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", function () {
      loadMoreWishlistItems();
    });
  }

  // Infinite scroll
  window.addEventListener("scroll", function () {
    if (isLoading || !hasMore) return;

    const scrollPosition = window.scrollY + window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // Load more when user scrolls to bottom of page
    if (scrollPosition >= documentHeight - 200) {
      loadMoreWishlistItems();
    }
  });

  /**
   * Load wishlist items
   */
  function loadWishlistItems() {
    isLoading = true;
    showLoading();

    // Fetch wishlist items
    fetch(wishlistData.ajaxUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "get_wishlist_items",
        nonce: wishlistData.nonce,
        page: currentPage,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        hideLoading();
        isLoading = false;

        if (data.success) {
          const items = data.data.items;
          hasMore = data.data.has_more;

          if (items.length === 0) {
            showEmptyWishlist();
          } else {
            hideEmptyWishlist();
            renderWishlistItems(items);

            if (hasMore) {
              showLoadMore();
            } else {
              hideLoadMore();
            }
          }
        } else {
          showNotification(
            data.data.message || wishlistData.i18n.errorOccurred,
            "error"
          );
        }
      })
      .catch((error) => {
        hideLoading();
        isLoading = false;
        showNotification(wishlistData.i18n.errorOccurred, "error");
        console.error("Error:", error);
      });
  }

  /**
   * Load more wishlist items
   */
  function loadMoreWishlistItems() {
    if (isLoading || !hasMore) return;

    isLoading = true;
    showLoadingMore();
    currentPage++;

    // Fetch more wishlist items
    fetch(wishlistData.ajaxUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "get_wishlist_items",
        nonce: wishlistData.nonce,
        page: currentPage,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        hideLoadingMore();
        isLoading = false;

        if (data.success) {
          const items = data.data.items;
          hasMore = data.data.has_more;

          if (items.length > 0) {
            appendWishlistItems(items);
          }

          if (!hasMore) {
            hideLoadMore();
          }
        } else {
          showNotification(
            data.data.message || wishlistData.i18n.errorOccurred,
            "error"
          );
        }
      })
      .catch((error) => {
        hideLoadingMore();
        isLoading = false;
        showNotification(wishlistData.i18n.errorOccurred, "error");
        console.error("Error:", error);
      });
  }

  /**
   * Remove item from wishlist
   *
   * @param {HTMLElement} item - Wishlist item element
   * @param {number} productId - Product ID
   */
  function removeFromWishlist(item, productId) {
    // Add loading state
    item.classList.add("is-loading");

    // Fetch request to remove item
    fetch(wishlistData.ajaxUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "remove_from_wishlist",
        nonce: wishlistData.nonce,
        product_id: productId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Remove item with animation
          item.classList.add("removing");

          // Wait for animation to complete
          setTimeout(() => {
            item.remove();

            // Check if wishlist is empty
            if (wishlistItems.children.length === 0) {
              showEmptyWishlist();
              hideLoadMore();
            }

            showNotification("محصول از لیست علاقه مندی حذف شد", "success");
          }, 300);
        } else {
          // Remove loading state
          item.classList.remove("is-loading");
          showNotification(
            data.data.message || wishlistData.i18n.errorOccurred,
            "error"
          );
        }
      })
      .catch((error) => {
        // Remove loading state
        item.classList.remove("is-loading");
        showNotification(wishlistData.i18n.errorOccurred, "error");
        console.error("Error:", error);
      });
  }

  /**
   * Add item to cart
   *
   * @param {HTMLElement} button - Add to cart button
   * @param {HTMLElement} item - Wishlist item element
   * @param {number} productId - Product ID
   * @param {number} variationId - Variation ID
   */
  function addToCart(button, item, productId, variationId) {
    // Add loading state
    button.textContent = wishlistData.i18n.addingToCart;
    button.disabled = true;
    
    // Fetch request to add to cart
    fetch(wishlistData.ajaxUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'add_to_cart_from_wishlist',
            nonce: wishlistData.nonce,
            product_id: productId,
            variation_id: variationId,
            quantity: 1,
        }),
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            // Replace button with quantity controls
            const actionsContainer = button.closest('.wishlist-item-actions');
            
            const quantityControls = document.createElement('div');
            quantityControls.className = 'wishlist-item-quantity';
            quantityControls.innerHTML = `
                <button class="quantity-btn quantity-decrease" aria-label="Decrease quantity">${minusIcon}</button>
                <span class="quantity-value">${data.data.quantity}</span>
                <button class="quantity-btn quantity-increase" aria-label="Increase quantity">${plusIcon}</button>
            `;
            
            // Replace button with quantity controls
            button.replaceWith(quantityControls);
            
            // Show success message
            showNotification(wishlistData.i18n.productAdded, 'success');
            
            // Update cart fragments if WooCommerce is available
            if (typeof wc_cart_fragments_params !== 'undefined') {
                jQuery(document.body).trigger('wc_fragment_refresh');
            }
        } else {
            // Reset button state
            button.textContent = wishlistData.i18n.addToCart;
            button.disabled = false;
            
            // Show error message
            showNotification(data.data.message || wishlistData.i18n.errorOccurred, 'error');
        }
    })
    .catch(error => {
        // Reset button state
        button.textContent = wishlistData.i18n.addToCart;
        button.disabled = false;
        
        // Show error message
        showNotification(wishlistData.i18n.errorOccurred, 'error');
        console.error('Error:', error);
    });
}

  /**
   * Update cart quantity
   *
   * @param {HTMLElement} quantityContainer - Quantity container element
   * @param {HTMLElement} item - Wishlist item element
   * @param {number} productId - Product ID
   * @param {number} variationId - Variation ID
   * @param {string} actionType - Action type (increase, decrease)
   */
  function updateCartQuantity(quantityContainer, item, productId, variationId, actionType) {
    // Add loading state
    quantityContainer.classList.add('is-loading');
    
    // Fetch request to update cart quantity
    fetch(wishlistData.ajaxUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'update_cart_quantity_from_wishlist',
            nonce: wishlistData.nonce,
            product_id: productId,
            variation_id: variationId,
            action_type: actionType,
        }),
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            // Remove loading state
            quantityContainer.classList.remove('is-loading');
            
            if (data.data.quantity === 0) {
                // Replace quantity controls with add to cart button
                const actionsContainer = quantityContainer.closest('.wishlist-item-actions');
                
                const addToCartButton = document.createElement('button');
                addToCartButton.className = 'add-to-cart-btn';
                addToCartButton.textContent = wishlistData.i18n.addToCart;
                
                // Replace quantity controls with button
                quantityContainer.replaceWith(addToCartButton);
            } else {
                // Update quantity value
                const quantityValue = quantityContainer.querySelector('.quantity-value');
                if (quantityValue) {
                    quantityValue.textContent = data.data.quantity;
                }
            }
            
            // Update cart fragments if WooCommerce is available
            if (typeof wc_cart_fragments_params !== 'undefined') {
                jQuery(document.body).trigger('wc_fragment_refresh');
            }
        } else {
            // Remove loading state
            quantityContainer.classList.remove('is-loading');
            
            // Show error message
            showNotification(data.data.message || wishlistData.i18n.errorOccurred, 'error');
        }
    })
    .catch(error => {
        // Remove loading state
        quantityContainer.classList.remove('is-loading');
        
        // Show error message
        showNotification(wishlistData.i18n.errorOccurred, 'error');
        console.error('Error:', error);
    });
}

  /**
   * Render wishlist items
   *
   * @param {Array} items - Wishlist items
   */
  function renderWishlistItems(items) {
    // Clear existing items
    wishlistItems.innerHTML = "";

    // Render each item
    items.forEach((item) => {
      const itemElement = createWishlistItemElement(item);
      wishlistItems.appendChild(itemElement);
    });
  }

  /**
   * Append wishlist items
   *
   * @param {Array} items - Wishlist items
   */
  function appendWishlistItems(items) {
    // Append each item
    items.forEach((item) => {
      const itemElement = createWishlistItemElement(item);
      wishlistItems.appendChild(itemElement);
    });
  }
  const tomaanIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><g fill="#000"><path d="M22.56 14.862c0 .685-.203 1.222-.61 1.612-.408.381-.954.572-1.639.572h-1.326c-.087 0-.13-.225-.13-.676 0-.485.043-.728.13-.728h1.326c.269 0 .486-.07.65-.208.165-.147.247-.35.247-.61V12.73h1.352v2.132ZM22.911 10v1.248h-3.536V10h3.536Z"/><path d="M20.305 15.642c.087 0 .13.243.13.728 0 .45-.043.676-.13.676h-1.157c-.087.988-.429 1.76-1.027 2.314-.59.555-1.365.832-2.327.832h-1.677L14 18.788h1.833c.615 0 1.1-.156 1.456-.468.355-.312.537-.737.546-1.274h-1.118c-.919 0-1.577-.186-1.976-.559-.399-.381-.598-.975-.598-1.78 0-.556.104-1.045.312-1.47a2.42 2.42 0 0 1 .897-.988c.39-.243.836-.364 1.339-.364.771 0 1.378.26 1.82.78.442.511.663 1.213.663 2.106v.871h1.131Zm-4.81-1c0 .363.095.623.286.78.19.146.524.22 1.001.22h1.053v-.845c0-.511-.104-.897-.312-1.157-.208-.269-.507-.403-.897-.403-.355 0-.633.13-.832.39-.2.251-.299.59-.299 1.014ZM7.812 15.596c.286 0 .49-.056.611-.169.13-.121.195-.308.195-.559v-.455c0-.832.23-1.49.69-1.976.467-.485 1.1-.728 1.898-.728.797 0 1.408.234 1.833.702.424.46.636 1.122.636 1.989 0 .823-.225 1.465-.676 1.924-.442.45-1.057.676-1.846.676-.442 0-.814-.06-1.117-.182-.304-.13-.525-.308-.664-.533a1.37 1.37 0 0 1-.61.546c-.243.113-.56.169-.95.169H7.5c-.086 0-.13-.225-.13-.676 0-.485.044-.728.13-.728h.312Zm4.524-1.196c0-.45-.1-.784-.299-1.001-.19-.225-.485-.338-.884-.338-.398 0-.697.113-.896.338-.191.217-.287.555-.287 1.014 0 .381.1.676.3.884.199.2.494.299.883.299.4 0 .694-.095.884-.286.2-.2.3-.503.3-.91Z"/><path d="M7.496 15.596c.043 0 .074.048.091.143.026.095.039.29.039.585 0 .277-.013.46-.039.546-.017.087-.048.13-.091.13h-.39c-.693 0-1.218-.204-1.573-.61-.355-.408-.533-.985-.533-1.73v-4.058h1.339v3.967c0 .355.065.615.195.78.139.165.355.247.65.247h.312ZM5.458 10.048c-1.11 0-1.963-.32-2.561-.962C2.299 8.453 2 7.561 2 6.408V3.886h1.339v2.496c0 1.508.71 2.262 2.132 2.262h.533c.693 0 1.24-.19 1.638-.572.399-.381.598-.906.598-1.573V3.586h1.352v2.796c0 .763-.152 1.417-.455 1.963a3.03 3.03 0 0 1-1.274 1.261c-.537.295-1.157.442-1.859.442h-.546Zm-.702-5.774V3h1.56v1.274h-1.56Z"/></g></svg>`;
  const trashIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="#FF0F48" d="M20.25 4.5h-3.375V3.375A2.625 2.625 0 0 0 14.25.75h-4.5a2.625 2.625 0 0 0-2.625 2.625V4.5H3.75a1.125 1.125 0 0 0 0 2.25h.375V19.5A1.875 1.875 0 0 0 6 21.375h12a1.875 1.875 0 0 0 1.875-1.875V6.75h.375a1.125 1.125 0 0 0 0-2.25ZM9.375 3.375A.375.375 0 0 1 9.75 3h4.5a.375.375 0 0 1 .375.375V4.5h-5.25V3.375Zm8.25 15.75H6.375V6.75h11.25v12.375Zm-6.75-9.375v6a1.125 1.125 0 1 1-2.25 0v-6a1.125 1.125 0 0 1 2.25 0Zm4.5 0v6a1.125 1.125 0 1 1-2.25 0v-6a1.125 1.125 0 1 1 2.25 0Z"/></svg>`;
  const plusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M21.375 12C21.375 12.2984 21.2565 12.5845 21.0455 12.7955C20.8345 13.0065 20.5484 13.125 20.25 13.125H13.125V20.25C13.125 20.5484 13.0065 20.8345 12.7955 21.0455C12.5845 21.2565 12.2984 21.375 12 21.375C11.7016 21.375 11.4155 21.2565 11.2045 21.0455C10.9935 20.8345 10.875 20.5484 10.875 20.25V13.125H3.75C3.45163 13.125 3.16548 13.0065 2.9545 12.7955C2.74353 12.5845 2.625 12.2984 2.625 12C2.625 11.7016 2.74353 11.4155 2.9545 11.2045C3.16548 10.9935 3.45163 10.875 3.75 10.875H10.875V3.75C10.875 3.45163 10.9935 3.16548 11.2045 2.9545C11.4155 2.74353 11.7016 2.625 12 2.625C12.2984 2.625 12.5845 2.74353 12.7955 2.9545C13.0065 3.16548 13.125 3.45163 13.125 3.75V10.875H20.25C20.5484 10.875 20.8345 10.9935 21.0455 11.2045C21.2565 11.4155 21.375 11.7016 21.375 12Z" fill="#5563BB"/>
</svg>`;
  const minusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M21.375 12C21.375 12.2984 21.2565 12.5845 21.0455 12.7955C20.8345 13.0065 20.5484 13.125 20.25 13.125H3.75C3.45163 13.125 3.16548 13.0065 2.9545 12.7955C2.74353 12.5845 2.625 12.2984 2.625 12C2.625 11.7016 2.74353 11.4155 2.9545 11.2045C3.16548 10.9935 3.45163 10.875 3.75 10.875H20.25C20.5484 10.875 20.8345 10.9935 21.0455 11.2045C21.2565 11.4155 21.375 11.7016 21.375 12Z" fill="#FF0F48"/>
</svg>`;

function createWishlistItemElement(item) {
    const itemElement = document.createElement('div');
    itemElement.className = 'card-product-horizontal card-product-horizontal__divider card-product-horizontal__divider-last wishlist-item';
    itemElement.dataset.productId = item.id;
    itemElement.dataset.productType = item.type;
    itemElement.dataset.productUrl = item.url;
    
    if (item.variation && item.variation.variation_id) {
        itemElement.dataset.variationId = item.variation.variation_id;
    }
    
    // Determine if the product is on sale
    const isOnSale = item.on_sale;
    const outOfStock = !item.is_in_stock;
    
    // Get price values
    let regularPrice = item.regular_price;
    let salePrice = item.sale_price;
    let currentPrice = item.price;
    
    // If we have variation data, use those prices instead
    if (item.variation && item.variation.price) {
        currentPrice = item.variation.price;
        
        if (item.variation.regular_price) {
            regularPrice = item.variation.regular_price;
        }
        
        if (item.variation.sale_price) {
            salePrice = item.variation.sale_price;
        }
    }
    
    // Format prices for display (add thousand separators)
    function formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    // Calculate discount percentage if on sale
    let discountPercentage = 0;
    if (isOnSale && regularPrice && salePrice) {
        discountPercentage = Math.round((regularPrice - salePrice) / regularPrice * 100);
    }
    
    // Check if this is a variable product without a selected variation
    const isVariableWithoutVariation = item.type === 'variable' && (!item.variation || !item.variation.variation_id);
    
    // Create item HTML
    itemElement.innerHTML = `
        <a class="card-product-horizontal__image ${outOfStock ? 'card-product-horizontal__image-out' : ''}" href="${item.url}">
            <img src="${item.image}" alt="${item.name}" />
        </a>
        
        <div class="card-product-horizontal__info">
            <a class="title" href="${item.url}">
                ${item.name}
            </a>
            
            ${item.variation && item.variation.attributes ? `
                <div class="wishlist-item-variations">
                    ${Object.entries(item.variation.attributes).map(([name, value]) => {
                        const formattedName = name.replace('attribute_pa_', '').replace('attribute_', '');
                        const displayName = formattedName.charAt(0).toUpperCase() + formattedName.slice(1);
                        return `<span class="variation-attribute" data-name="${name}" data-value="${value}"><strong>${displayName}:</strong> ${value}</span>`;
                    }).join('')}
                </div>
            ` : ''}
            
            ${isOnSale && discountPercentage > 0 ? `
                <div class="badge-holder">
                    <div class="badge badge-red">
                        ${discountPercentage}% تخفیف
                    </div>
                </div>
            ` : ''}
            
            <div class="price-holder">
                <div class="price">
                    ${outOfStock ? `
                        <span class="price-out">تمام شد</span>
                    ` : `
                        <span class="price-new">
                            ${formatPrice(currentPrice)}
                        </span>
                        
                        ${isOnSale && regularPrice ? `
                            <span class="price-old">
                                <del>${formatPrice(regularPrice)}</del>
                            </span>
                        ` : ''}
                    `}
                </div>
                
                ${!outOfStock ? `
                    <div class="tomaan">
                        ${tomaanIcon}
                    </div>
                ` : ''}
            </div>
            
            <div class="wishlist-item-actions">
                ${item.in_cart > 0 && !isVariableWithoutVariation ? `
                    <div class="wishlist-item-quantity">
                        <button class="quantity-btn quantity-decrease" aria-label="Decrease quantity">${minusIcon}</button>
                        <span class="quantity-value">${item.in_cart}</span>
                        <button class="quantity-btn quantity-increase" aria-label="Increase quantity">${plusIcon}</button>
                    </div>
                ` : `
                    <button class="add-to-cart-btn">${isVariableWithoutVariation ? wishlistData.i18n.selectOptions : wishlistData.i18n.addToCart}</button>
                `}
                <button class="remove-from-wishlist-btn" aria-label="${wishlistData.i18n.removeFromWishlist}">
                    ${trashIcon}
                </button>
            </div>
        </div>
    `;
    
    return itemElement;
}
  /**
   * Show notification
   *
   * @param {string} message - Notification message
   * @param {string} type - Notification type (success, error)
   */
  function showNotification(message, type) {
    const notification = document.createElement("div");
    notification.className = `wishlist-notification ${type}`;
    notification.textContent = message;

    wishlistNotifications.appendChild(notification);

    // Remove notification after 3 seconds
    setTimeout(() => {
      notification.classList.add("removing");

      // Wait for animation to complete
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }

  /**
   * Show loading
   */
  function showLoading() {
    wishlistLoading.classList.remove("hidden");
  }

  /**
   * Hide loading
   */
  function hideLoading() {
    wishlistLoading.classList.add("hidden");
  }

  /**
   * Show loading more
   */
  function showLoadingMore() {
    wishlistLoadingMore.classList.remove("hidden");
    wishlistLoadMore.classList.add("hidden");
  }

  /**
   * Hide loading more
   */
  function hideLoadingMore() {
    wishlistLoadingMore.classList.add("hidden");
    if (hasMore) {
      wishlistLoadMore.classList.remove("hidden");
    }
  }

  /**
   * Show empty wishlist
   */
  function showEmptyWishlist() {
    wishlistEmpty.classList.remove("hidden");
    wishlistItems.classList.add("hidden");
  }

  /**
   * Hide empty wishlist
   */
  function hideEmptyWishlist() {
    wishlistEmpty.classList.add("hidden");
    wishlistItems.classList.remove("hidden");
  }

  /**
   * Show load more
   */
  function showLoadMore() {
    wishlistLoadMore.classList.remove("hidden");
  }

  /**
   * Hide load more
   */
  function hideLoadMore() {
    wishlistLoadMore.classList.add("hidden");
  }
});
